export const state = {
  routerPage: 'pk10',
  headTabs: [
    {
      top: '北京',
      b: 'PK10',
      active: true,
      title: '北京PK10',
      path: '/home/pk10'
    },
    {
      top: '重庆',
      b: '时时彩',
      active: true,
      title: '重庆时时彩',
      path: '/home/cc_ssc'
    },
    {
      top: '幸运',
      b: '飞艇',
      active: true,
      title: '幸运飞艇',
      path: '/home/lucky_ft'
    },
    {
      top: '广东',
      b: '快乐十分',
      active: true,
      path: '/home/gd_ha10',
      title: '广东快乐十分',
    },
    {
      top: '重庆',
      b: '幸运农场',
      active: true,
      path: '/home/cc_lu',
      title: '重庆幸运农场',

    },
    {
      top: '极速',
      b: '赛车',
      active: true,
      path: '/home/fast_car',
      title: '极速赛车',

    },
    {
      top: '极速',
      b: '时时彩',
      active: true,
      path: '/home/fast_ssc',
      title: '极速时时彩'
    },
    {
      top: '幸运',
      b: '时时彩',
      active: true,
      title: '幸运时时彩',
      path: '/home/lucky_ssc'
    }
  ]
};

export const actions = {
  setHeadTabs ({commit}, tabs) {
    if (!tabs.length) return;
    commit('SET_HEAD_TABS', tabs);
  }
};

export const mutations = {
  ['SET_HEAD_TABS'] (state, tabs) {
    state.headTabs = tabs;
  }
};

export const getters = {
  headTabs: state => state.headTabs
};



// WEBPACK FOOTER //
// ./src/pages/home/store.js